<template>
  <div class="credits">
    <section class="headtop">
      <div class="container">
        <div class="col-sm-9 right-border">
          <h1>
            Lessons
          </h1>
          <br>
          <RunButtons />
        </div>
        <div class="col-sm-3">
          <CovidStatus />
        </div>
        <div class="clearfix" />
      </div>
    </section>

    <div class="container lessons">
      <div class="row">
        <div class="text-body col-md-10">
          <h4>Background</h4>
          <p>
            In the first phase of lockdown, ‘hard’ lockdown, people are told to
            stay at home so far as possible. Later, under ‘soft’ lockdown, there
            is no compulsion to stay at home, but social distancing restrictions
            still limit how many people can travel safely on buses and trains or
            can gather in workplaces.
          </p>
          <p>
            Furloughed staff stay at home and are assumed not to contribute to
            GVA.
          </p>
          <p>
            This all reduces the numbers of people travelling to work, and
            increases the numbers working from home (WFH). It also reduces
            non-commuting trips.
          </p>
          <p>
            The periods of hard and soft lockdown vary between scenarios, but in
            only one of them, the Vaccine scenario, do all social distancing
            restrictions end.
          </p>
          <p>
            Click below to see how lockdown intensity varies over time under each scenario
          </p>
          <p>
            <ul>
              <li>
                <a
                  href="/static/img/udm/LockdownChart-CoL.png"
                  target="_blank"
                >Cycles of lockdown</a>
              </li>
              <li>
                <a
                  href="/static/img/udm/LockdownChart-Ada.png"
                  target="_blank"
                >Adaptation</a>
              </li>
              <li>
                <a
                  href="/static/img/udm/LockdownChart-Ther.png"
                  target="_blank"
                >Therapeutics</a>
              </li>
              <li>
                <a
                  href="/static/img/udm/LockdownChart-Vacc.png"
                  target="_blank"
                >Vaccine</a>
              </li>
            </ul>
          </p>
          <h4>
            Reducing parking spaces
          </h4>
          <p>
            This has no effect on travel during COVID because car travel is well
            below the town’s parking capacity. In practice, the space that is
            released could be put to new uses, but that is beyond what this
            model can represent.
          </p>
          <h4>
            Increasing bus and rail capacity
          </h4>
          <p>
            The carrying capacity on bus and rail can be increased, although it
            will still be below its original level. This allows more people to
            be carried, but the effect can be limited by workplace capacity.
            This can be seen especially clearly in the Cycles of Lockdown
            Scenario, where the on/off pattern of lockdown causes a rippling
            pattern in commuter bus passenger numbers in the reference case.
            Increasing bus capacity allows more people to travel, but even more
            people use bus if workplace capacity is also increased.
          </p>
          <h4>
            Increasing workplace capacity
          </h4>
          <p>
            This allows more people into their workplace, but the volumes may be
            constrained by the capacity of the transport system to get them
            there. In this town car is dominant, so the constraint is not too
            great; towns or cities more heavily dependent on public transport
            will experience this problem more severely.
          </p>
          <h4>
            Reducing public transport fares
          </h4>
          <p>
            This has no effect on its own, other than to reduce operator
            revenues, because public transport is operating at the limit of its
            safe carrying capacity.
          </p>
          <h4>
            Improvements to walk and cycle
          </h4>
          <p>
            Walk and cycle trip numbers reduce under lockdown, but improvements
            do make them more attractive and increase their numbers somewhat.
          </p>
          <h4>
            Open offices more days
          </h4>
          <p>
            This reduces daily commuting volumes while keeping people in work.
            The effect is to reduce the daily strain on the transport system.
            Peak spreading has a similar effect, reducing the strain on the
            system.
          </p>
          <h4>
            Boosting public confidence
          </h4>
          <p>
            This makes people quicker to increase trip rates and more reluctant
            to reduce them. This produces short term effects, particularly in
            the use of bus and rail, where usage rises more quickly after
            lockdown is relaxed, reaching a higher level. This is particularly
            apparent under the Cycles of Lockdown scenario.
          </p>
          <h4>
            Overall
          </h4>
          <p>
            Varying transport conditions has surprisingly little effect on
            employment or GVA, largely because the factors affecting them are
            furloughing and accelerated closures of businesses that happen under
            lockdown, neither of which are affected - in the model - by
            transport. The biggest differences in outcomes are between the four
            scenarios, especially for the Vaccine scenario.
          </p>
          <p>
            However, public transport does constrain travel activity, and if the
            safe carrying capacity on buses and trains can be increased this
            will increase the numbers of people able to get in to work –
            providing the workplace capacity is there to accommodate them – and
            generate more non-commuting travel. This has an immediate beneficial
            effect on public transport revenues.
          </p>
          <p>
            The balance between workplace capacity and transport capacity is
            crucial. Maintaining public confidence helps keep travelling numbers
            up and maintain public transport revenues.
          </p>
          <h4>
            In the longer term
          </h4>
          <p>
            The first three scenarios have very similar outcomes, largely
            because social distancing continues to restrict travel in all of
            them, limiting travel and requiring people to WFH.
          </p>
          <p>
            The Vaccine scenario stands out as different, because all social
            distancing restrictions are lifted in week 80, allowing travel
            behaviour to adjust back to pre-COVID types. However, the model
            assumes that employers will continue to use at least some WFH
            because it reduces their costs, leading to a surplus of empty office
            space and lower rents. In time, the availability of low-rent
            commercial property helps stimulate recovery.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CovidStatus from "../components/CovidStatus";
import RunButtons from "../components/RunButtons";

export default {
  components: {
    CovidStatus,
    RunButtons
  },
  mounted() {},
  methods: {}
};
</script>

<style lang="scss">
.lessons {
  .text-body {
    margin: 15px 15px 40px 15px;
    h4 {
      margin: 25px 0 15px 0;
    }
  }
}
</style>
